import axios from "axios";
import store from '@/store'
import router from "@/router";
import {findObjectIndex} from "../class/Converter";
import {toast} from "../class/Notification";

const ticketDataShape = (form) => {

    let data = {
        name: form.ticket_subject,
        priority: form.ticket_status,
        ticketable_id: 1,
        text: form.ticket_description,
    }

    if (form.user_id != "") {
        data = {...data, user_id: form.user_id}
    } else {
        data = {...data, user_id: store.getters['User/getUserId']}
    }

    if (form.ticket_type != "null") {
        data = {...data, ticket_type: form.ticket_type}
    }

    let formData = new FormData();

    for (let [index, value] of Object.entries(form.files)) {
        formData.append(`files[${index}]`, value);
    }

    for (let [index, value] of Object.entries(data)) {
        formData.append(index, value);
    }

    return formData;
}

const messageDataShape = (form) => {
    let formData = new FormData();
    formData.append('text', form.message_for_send);
    formData.append('ticket_id', store.getters['Ticket/getTicketId']);
    formData.append('user_id', store.getters['User/getUserId']);

    for (let [index, value] of Object.entries(form.files)) {
        formData.append(`files[${index}]`, value);
    }
    return formData;
}
export const ticket_types = {
    brand: "برند",
    product: "محصول",
    category: "دسته‌بندی",
    order: "سفارش",
    null: "پیام"
};
export default {
    namespaced: true,
    state: {
        tickets: [],
        messages: [],
        trash: [],
        meta: {},
        ticketinfo: {},
        links: {},
    },
    mutations: {
        setTickets(state, tickets) {
            state.tickets = tickets;
        },
        setMessages(state, messages) {
            state.messages = messages;
        },
        setLinks(state, links) {
            state.links = links;
        },
        setTrash(state, tickets) {
            state.trash = tickets;
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        deleteTicket: (state, ticket) => {
            state.tickets.splice(
                findObjectIndex(store.getters["ticket/tickets"], ticket),
                1
            );
            state.trash.splice(
                findObjectIndex(store.getters["ticket/gettrash"], ticket),
                1
            );
        },
        setTicketinfo(state, ticketinfo) {
            state.ticketinfo = ticketinfo;
        },
    },
    actions: {
        getTickets({commit}, page = 1) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/ticket?page=${page}`)
                    .then((response) => {
                        response = response.data.data;
                        commit("setTickets", response.data);
                        commit("setLinks", response.links);
                        commit("setMeta", response.meta);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getTicket({commit}, {ticket_id, user_id, scroll = false}) {
            axios.get(`/ticket/${ticket_id}/user/${user_id}`)
                .then(async res => {
                    const messages = res.data.data;
                    await commit('setMessages', messages);
                    await commit('setTicketinfo', ticket_id)

                    if (scroll != false) {
                        var element = document.getElementById(scroll);
                        element.scrollTop = element.scrollHeight;
                    }

                })
                .catch(error => {
                    console.log(error)
                })
        },
        reply({commit}, {form, user_id}) {
            const id = store.getters['User/getUserId'];
            const ticket_id = store.getters['Ticket/getTicketId'];
            let formData = messageDataShape(form);

            axios.post(`/ticketmessage/user/${id}/ticket/${ticket_id}`, formData)
                .then(async res => {
                    const ticket = res.data.data;
                    store.dispatch('Ticket/getTicket', {ticket_id: ticket_id, user_id: user_id})
                    toast("عملیات با موفقیت انجام شد", "پیام با موفقیت ارسال شد.");
                })

        },
        setTrash({commit}) {
            axios.post('ticket/trash')
                .then(res => {
                    const data = res.data.data;
                    commit("setTrash", data)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        forceDeleteTicket({commit}, ticket) {
            axios
                .delete(`ticket/${ticket.id}/force-delete`)
                .then((res) => {
                    const deletedMeta = res.data.data;
                    store.dispatch('Ticket/setTrash')
                    toast("عملیات با موفقیت انجام شد", "حذف با موفقیت انجام شد.");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        restoreTicket({commit}, ticket) {
            axios.put(`ticket/${ticket.id}/restore`)
                .then(res => {
                    const ticket = res.data.data;
                    store.dispatch('Ticket/setTrash')
                    toast("عملیات با موفقیت انجام شد", "بازیابی با موفقیت انجام شد.");
                })
                .catch(error => {
                    console.log(error)
                })
        },
        deleteTicket({commit}, {ticket, page}) {
            axios
                .delete(`/ticket/${ticket.id}`)
                .then((res) => {
                    const deletedticket = res.data.data;
                    store.dispatch('Ticket/getTickets', page)
                    toast("عملیات با موفقیت انجام شد", "حذف با موفقیت انجام شد.");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async createticket({commit}, form) {
            await axios.post(`/ticket`, ticketDataShape(form))
                .then(async res => {
                    const ticket = await res.data.data;
                    await router.push({name: 'TicketMessages', params: {ticket: ticket.id, user: ticket.user.id}})
                    toast("عملیات با موفقیت انجام شد", "پیام با موفقیت ایجاد شد.");
                })

        },
        UpdateTicket({commit}, {form, ticket_id}) {
            axios.put(`/ticket/${ticket_id}`, form)
                .then((res) => {
                    let response = res.data.data;
                    toast("عملیات با موفقیت انجام شد", "وضعیت با موفقیت ویرایش شد.");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getUserTickets({commit}, page = 1) {
            const id = store.getters['User/getUserId'];
            return new Promise((resolve, reject) => {
                axios
                    .get(`/user/ticket/${id}?page=${page}`)
                    .then((response) => {
                        response = response.data.data;
                        commit("setTickets", response.data);
                        commit("setLinks", response.links);
                        commit("setMeta", response.meta);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
    getters: {
        getTickets: state => state.tickets,
        getTicket: state => state.messages,
        getTicketId: state => state.ticketinfo,
        getTrash: (state) => state.trash,
        getPaginationMeta: (state) => state.meta,
        getPaginationLinks: (state) => state.links,
        setTrash: (state) => state.trash,
        tickets: (state) => state.tickets,
    },
};